import { Text, TouchableOpacity, View } from "react-native";
import Address from "./Address";
import { Employment } from "../screens/types";
import Checkmark from "../svgs/Checkmark";

const SelectableEmploymentTile = ({
  employment,
  selectedEmployment,
  handleSwitch,
}: {
  employment: Employment;
  selectedEmployment: string;
  handleSwitch: (id: string) => void;
}) => {
  const isSelectedEmployment = employment.id === selectedEmployment;
  return (
    <TouchableOpacity
      onPress={() => handleSwitch(employment.id)}
      key={employment.id}
      className={`rounded-lg border ${
        isSelectedEmployment ? "border-primary-lighter border-2" : "border-sky-dark"
      } bg-white p-5 mb-4 relative`}
    >
      <View className="flex-row">
        <View className="w-5 mr-3 justify-center">
          <View
            className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
              isSelectedEmployment ? "border-primary bg-primary" : "border-[#CDCFD0] bg-white"
            }`}
          >
            {isSelectedEmployment && <Checkmark height={18} stroke="white" />}
          </View>
        </View>
        <View className="flex-1">
          <View className="flex-row justify-between items-center mb-2 min-h-[28px]">
            <Text className="text-regular-tight font-500 text-ink-dark flex-1 mr-2" numberOfLines={2}>
              {employment.title}
            </Text>
            <View className="w-20 items-end">
              {isSelectedEmployment && (
                <View className="bg-gray-200 rounded-full px-3 py-1">
                  <Text className="text-xs text-gray-600">Primary</Text>
                </View>
              )}
            </View>
          </View>
          <Text className="text-small-normal text-ink-dark">{employment.facility.name}</Text>
          {employment.facility.addresses.length > 0 && (
            <View className="mt-1">
              <Address textClassName="text-small-normal text-ink-dark" address={employment.facility.addresses[0]} />
            </View>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default SelectableEmploymentTile;
